import React, { FC } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import PersonSimpleView from '../PersonSimpleView/PersonSimpleView';

const useStyles = makeStyles({
  btn: {
    padding: '2px 6px 2px 0',
    textTransform: 'none',
    pointerEvents: ({ hasOnClick }: IStyle) => (hasOnClick ? 'auto' : 'none'),
  },
  avatar: {
    width: '28px',
    height: '28px',
  },
});

interface IStyle {
  hasOnClick: boolean;
}

interface IMemberName {
  firstName: string;
  lastName: string;
  status?: string;
  photoUrl?: string | null;
  onClick?: () => void;
  code?: string | number;
  title?: string;
}

const MemberName: FC<IMemberName> = ({
  firstName,
  lastName,
  status,
  photoUrl,
  onClick,
  code,
  title,
}) => {
  const classes = useStyles({ hasOnClick: !!onClick });

  return (
    <Button className={classes.btn} onClick={onClick}>
      <PersonSimpleView
        bold
        firstName={firstName}
        lastName={lastName}
        title={title}
        imageUrl={photoUrl}
        memberStatus={status}
        code={code}
      />
    </Button>
  );
};

export default React.memo(MemberName);
